import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../../../../store/StoreManager';
import properties from '../../../../../constants/Properties';
import platformDetection from '../../../../utils/PlatformDetection';
import mouseUtils from '../../../../utils/MouseUtils';
import { ScrollableComponent } from '../../../ScrollableComponent';
import { expandFontLineHeight } from '../../../../../actions/MenuActions';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeTextProperties();
    },
    onButtonClick() {
        let downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeTextProperties();
    },
    changeTextProperties() {
        if (this.props.executeCommand) {
            storeManager.getStore().dispatch(expandFontLineHeight(false));

            this.props.executeCommand(18, this.props.value);
            this.props.refresh();

            setTimeout(function() {
                let lineHeightButton = document.getElementById('fontLineHeightMenu');

                if (lineHeightButton)
                    lineHeightButton.focus();
            }.bind(this), 10);
        }
    },
    render() {
        let iconColor;
        let buttonColor;

        if (this.state.isOver === true) {
            iconColor = properties.CONTEXT_HOVER_COLOR;
            buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
        } else {
            iconColor = 'black';
            buttonColor = properties.SLIDE_MENU_COLOR;
        }

        let topPosition = this.props.index * this.props.height;

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.width,
            height: this.props.height,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 15,
            top: topPosition,
            color: 'white',
            borderStyle: 'none'
        };

        let spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 17,
            fontFamily: this.props.value,
            top: 0
        };

        let iconVisible;

        if (this.props.index === this.props.selectedIndex)
            iconVisible = 'block';
        else
            iconVisible = 'none';

        const iconStyle = {
            position: 'absolute',
            top: 4,
            right: 10,
            color: iconColor,
            display: iconVisible
        };

        if (platformDetection.isIOS() === true) {
            spanStyle.fontSize = 18;
        }

        return (
            <button aria-label={this.props.value} ref="button" className='lineHeightButton' style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onButtonClick} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                <span className='lineHeightButton' style={spanStyle}>{this.props.value}</span>
                <i style={iconStyle} className='fa fa-check lineHeightButton'></i>
            </button>
        );
    }
});

const FontLineHeightMenuContent = React.createClass({
    onExpand(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const isExpanded = !this.props.fontLineHeightIsExpanded;
        this.props.dispatch(expandFontLineHeight(isExpanded));
    },
    getCurrentLineSize() {
        const shapes = storeManager.getState().currentSlide.model.content;
        let lineHeight;

        for (let i=0; i<shapes.length; i++) {
            if (shapes[i].uuid === this.props.contextTarget.uuid) {
                lineHeight = shapes[i].lineHeight;
                break;
            }
        }

        if (!lineHeight)
            lineHeight = 1.25;

        return lineHeight;
    },
    refreshView() {
        setTimeout(function () {
            this.forceUpdate();
        }.bind(this), 5);
    },
    render() {
        const dataProvider = [0.25, 0.5, 0.75, 1.0, 1.25, 1.50, 1.75, 2.0];
        const currentLineSize = this.getCurrentLineSize();
        let menuWidth = 80;
        let visibleItems = 8;
        let buttonHeight = 25;

        const menuStyle = {
            position: 'absolute',
            width: menuWidth,
            height: buttonHeight * visibleItems,
            top: this.props.top,
            right: 0,
            borderColor: properties.EFFECTS_BUTTON_BORDER_COLOR,
            borderWidth: 1,
            borderStyle: 'solid',
            display: listDisplay,
            overflowY: 'hidden',
            overflowX: 'hidden',
            zIndex: 1100
        };

        let elements = [];
        let listDisplay;

        if (this.props.fontLineHeightIsExpanded === true) {
            let i;
            let selectedIndex = -1;

            for (i=0; i<dataProvider.length; i++) {
                if (currentLineSize === dataProvider[i])
                    selectedIndex = i;

                elements.push(<Button refresh={this.refreshView} contextTarget={this.props.contextTarget} height={buttonHeight} width={menuWidth} index={i} dispatch={this.props.dispatch} key={'lineHeight' + dataProvider[i]} value={dataProvider[i]} selectedIndex={selectedIndex} executeCommand={this.props.executeCommand}/>);
            }

            listDisplay = 'block';
        } else {
            listDisplay = 'none';
        }

        let componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = menuStyle.width;
        componentProperties.height = menuStyle.height;
        componentProperties.scrollHeight = dataProvider != undefined ? dataProvider.length * buttonHeight : 0;
        componentProperties.top = 0;
        componentProperties.displayState = 'block';
        componentProperties.elements = elements;

        return (
            <div style={menuStyle}>
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const fontLineHeightIsExpanded = state.menu.fontLineHeightIsExpanded;

    return {
        fontLineHeightIsExpanded
    };
}

export const FontLineHeightMenu = connect(mapStateToProps)(FontLineHeightMenuContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/subcomponents/FontLineHeightMenu.js
 **/